const translations = {
    opacity: 'Opacity'
};

export default translations;
